import { Currency } from '__generated__/globalTypes';
import { useCurrentUserContext } from 'contexts/currentUser';

import { useCryptoBalance } from './useCryptoBalance';
import { useFiatBalance } from './wallets/useFiatBalance';

export const useCurrentUserCurrencies = () => {
  const { currency } = useCurrentUserContext();
  const { fiatCurrency, fiatCurrencySymbol } = useFiatBalance();
  const { cryptocurrency, cryptocurrencySymbol } = useCryptoBalance();

  return {
    currency,
    mainCurrency: currency === Currency.ETH ? cryptocurrency : fiatCurrency,
    mainCurrencySymbol:
      currency === Currency.ETH ? cryptocurrencySymbol : fiatCurrencySymbol,
    fiatCurrency,
    cryptocurrency,
    fiatCurrencySymbol,
    cryptocurrencySymbol,
  };
};
